import AppStore from '@v4/store/appStore'
import QuestionsBuilderSelector from '@v4/utils/selectors/QuestionsBuilderSelector'

const useQuestionId = () => {
	const isBuilderMode = AppStore.useStoreState(state => state.general.isBuilderMode)

	const appId = AppStore.useStoreState(state => state.question.data?.id)
	const activeQuestionId = QuestionsBuilderSelector.useActiveQuestionId()

	return isBuilderMode ? activeQuestionId : appId
}

export default useQuestionId
